import { EventRegistry } from '../../../../../domain/event/event.registry';
import { FieldEvent } from './field.event';
export class FieldUpdatedEvent extends FieldEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `field/${payload.id}`,
            type: FieldUpdatedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
FieldUpdatedEvent.type = 'com.treeplotter.api.field.updated.v1';
EventRegistry.register(FieldUpdatedEvent.type, FieldUpdatedEvent);
//# sourceMappingURL=field-updated.event.js.map